module.exports = __webpack_public_path__ + "img/card-faq-kynorelle.e0bc63dd.webp";